export default __webpack_public_path__ + "static/media/img_04.fea4cf0c.jpg";